import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { escapeRegExp, filter, flatMap } from 'lodash-es';
import emojiData from './emoji.json';

@Component({
  selector: 'shared-emoji-component',
  imports: [
    MatTabsModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
  ],
  templateUrl: './emojiComponent.html',
  styleUrl: './emojiComponent.scss',
})
export class EmojiComponent {
  @Output() emojiSelected = new EventEmitter<string>();

  emojis = emojiData;
  searchTerm = '';
  filteredEmojis: { name: string; code: string }[] = [];
  private allEmojis = flatMap(flatMap(this.emojis, 'subGroups'), 'emojis');

  getEmoji(code: string): string {
    return String.fromCodePoint(...code.split(' ').map(c => parseInt(c.replace('U+', ''), 16)));
  }

  onSearchTermChange(): void {
    if (this.searchTerm.length < 3) {
      this.filteredEmojis = [];
      return;
    }
    const search = new RegExp(escapeRegExp(this.searchTerm), 'i');
    this.filteredEmojis = filter(this.allEmojis, emoji => search.test(emoji.name));
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.filteredEmojis = [];
  }

  selectEmoji(code: string): void {
    this.emojiSelected.emit(this.getEmoji(code));
  }
}
